import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function HLHybrid() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1417">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1418">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1419">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1420">
            WHAT IS A HYBRID LASER?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1421"></div>

          <p className="text-[#333333] text-[17px] leading-[1.8] font-body mb-12" data-id="element-1422">
            The Halo Laser utilizes hybrid fractional laser technology that
            combines the benefits of both ablative and non-ablative lasers in a
            single treatment. Using both types of lasers in one treatment, it
            offers enhanced results like smoother texture, improved tone,
            reduced wrinkles and a more youthful appearance with minimal
            downtime compared to traditional ablative lasers.
          </p>

          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-1423">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-1424">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-1425">
              This laser is inexplicably superior to any other laser I've seen
              on the market. Within two weeks after your treatment you will
              start to see a radiant glow that you didn't think was possible for
              your skin. It's like turning back the clock!
            </p>
          </div>
        </AnimateOnScroll>
      </div>

      <div className="max-w-[1000px] mx-auto px-6 lg:px-8" data-id="element-1426">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1427">
          <AnimateOnScroll data-id="element-1428">
            <div className="bg-white p-10 shadow-[0_4px_16px_rgba(0,0,0,0.06)] border-t-[3px] border-[#FF1493] h-full" data-id="element-1429">
              <h3 className="text-black text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-1430">
                Ablative Mode
              </h3>
              <p className="text-[#333333] text-[15px] leading-[1.7] font-body" data-id="element-1431">
                This mode targets the outermost layer of the skin (epidermis)
                and creates microscopic channels or injuries in the skin. These
                micro-injuries stimulate the body's natural healing process,
                prompting the production of new, healthy skin cells to replace
                the damaged ones. This process leads to skin renewal, improved
                texture, and a reduction in superficial imperfections like fine
                lines, wrinkles and uneven pigmentation.
              </p>
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll delay={150} data-id="element-1432">
            <div className="bg-white p-10 shadow-[0_4px_16px_rgba(0,0,0,0.06)] border-t-[3px] border-[#FF1493] h-full" data-id="element-1433">
              <h3 className="text-black text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-1434">
                Non-Ablative Mode
              </h3>
              <p className="text-[#333333] text-[15px] leading-[1.7] font-body" data-id="element-1435">
                This mode penetrates deeper into the skin (dermis) without
                causing significant damage to the surface layer. Instead, it
                heats the deeper layers of the skin, stimulating collagen
                production and tightening the skin's underlying structures. This
                results in improved skin firmness, elasticity and overall
                rejuvenation.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}